// libraries.
import { Outlet } from 'react-router-dom';

// components.

export const PolygonViewerPage = () => {
  return (
    <>
      <Outlet />
    </>
  );
};
